export const changeUserStateToStudent = () => {
    return {
        type : "STUDENT"
    }
}